import { Laptop } from '../parts/tech'
import type { AssetContext, AssetDefinition } from '../types'

/** Almost-shut lid: a hair of daylight keeps the two shells from z-fighting. */
const CLOSED = 0.02

/**
 * Laptop resting on a surface: y = 0 is the tabletop plane, the keyboard deck
 * faces the viewer and the lid hinges away towards -Z.
 */
function LaptopDesk({ variant = 'abierto' }: AssetContext) {
  return <Laptop open={variant === 'cerrado' ? CLOSED : 1} />
}

export const definition: AssetDefinition = {
  id: 'laptop-desk',
  name: 'Portátil',
  category: 'tech',
  footprint: [0.35, 0.25],
  height: 0.24,
  stackable: true,
  variants: [
    { id: 'abierto', name: 'Abierto' },
    { id: 'cerrado', name: 'Cerrado' },
  ],
  keywords: ['portatil', 'portátil', 'laptop', 'ordenador', 'notebook', 'computer'],
  Component: LaptopDesk,
}
